const AccountsBlockchainAddressesFragment = `
    id
    name
`

export default AccountsBlockchainAddressesFragment
